import { handleRequest } from "../utilities/requestHandler";

export const getAnalyticsOrders = (req_body) => 
    handleRequest("post", "/orders/getAnalyticsOrders", req_body);

export const getMostRequestedParts = (req_body) => 
    handleRequest("post", "/request_list/getMostRequestedParts", req_body);